import { render, staticRenderFns } from "./orderApproveList.vue?vue&type=template&id=6b2099d5&scoped=true"
import script from "./orderApproveList.vue?vue&type=script&lang=js"
export * from "./orderApproveList.vue?vue&type=script&lang=js"
import style0 from "./orderApproveList.vue?vue&type=style&index=0&id=6b2099d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2099d5",
  null
  
)

export default component.exports